import React, { useState, useEffect, memo, lazy, Suspense } from 'react';
import './about.css';

// Lazy load components for better performance
const About_all = lazy(() => import('./components/About_all'));
const OurCommitment = lazy(() => import('./components/OurCommitment'));
const About_service = lazy(() => import('./components/About_service'));
const Milestones = lazy(() => import('./components/Milestones'));

// Loading skeleton component
const LoadingSkeleton = memo(() => (
  <div className="loading-skeleton">
    <div className="skeleton-banner"></div>
    <div className="skeleton-content">
      <div className="skeleton-line long"></div>
      <div className="skeleton-line medium"></div>
      <div className="skeleton-line short"></div>
    </div>
  </div>
));

LoadingSkeleton.displayName = 'LoadingSkeleton';

// Banner component - only title animates via CSS
const BannerSection = memo(() => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    // Preload banner image
    const img = new Image();
    img.onload = () => setImageLoaded(true);
    img.src = '/images/about.jpeg';
  }, []);

  return (
    <div className={`banner-section-about ${imageLoaded ? 'image-loaded' : 'image-loading'}`}>
      <h1 className="banner-title-about">
        About AMDDAS Foods
      </h1>
      {!imageLoaded && <div className="banner-loading-overlay"></div>}
    </div>
  );
});

BannerSection.displayName = 'BannerSection';

// Main About component - all sections load statically
const About = memo(() => {
  return (
    <div className="about-page-container">
      <BannerSection />
      
      <div className="about-section">
        <Suspense fallback={<LoadingSkeleton />}>
          <div className="section-wrapper">
            <About_all />
          </div>
        </Suspense>

        <Suspense fallback={<LoadingSkeleton />}>
          <div className="section-wrapper">
            <OurCommitment />
          </div>
        </Suspense>

        <Suspense fallback={<LoadingSkeleton />}>
          <div className="section-wrapper">
            <About_service />
          </div>
        </Suspense>

        <Suspense fallback={<LoadingSkeleton />}>
          <div className="section-wrapper">
            <Milestones />
          </div>
        </Suspense>
      </div>
    </div>
  );
});

About.displayName = 'About';

export default About;